import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'
import { captureApiException } from '@/utility/sentry'

export const useMarketplaceStore = defineStore('marketplace', () => {
    const projectId = ref(null)
    const topJobs = ref(null)

    function buildMarketplaceV6Query ({
        cue,
        page = 1,
        size = 20,
        source = 'web',
        projectid = '0',
        region = [],
        jobIndustry = []
    }) {
        const params = new URLSearchParams({
            cue,
            page: String(page),
            size: String(size),
            source,
            projectid: String(projectid)
        })

        if (Array.isArray(region) && region.length > 0) {
            params.set('region', region.join(','))
        }

        if (Array.isArray(jobIndustry) && jobIndustry.length > 0) {
            params.set('jobIndustry', jobIndustry.join(','))
        }

        return params.toString().replace(/%2C/g, ',')
    }

    async function fetchMarketplaceV6 ({
        datawarehouse,
        token,
        cue,
        page = 1,
        size = 20,
        source = 'web',
        projectid = '0',
        region = [],
        jobIndustry = [],
        signal = {} // Added default empty object to match V2
    }) {
        const headers = {
            Authorization: 'Bearer ' + token
        }
        
        const base = datawarehouse + 'partner/projects/marketplaceV6'
        const queryString = buildMarketplaceV6Query({
            cue,
            page,
            size,
            source,
            projectid,
            region,
            jobIndustry
        })

        try {
            const response = await axios.get(`${base}?${queryString}`, { headers, signal })
            return response.data.data
        } catch (e) {
            captureApiException(e, 'marketplace.js', 'fetchMarketplaceV6')
            console.error(e)
        }
    }

    async function fetchMarketplaceV2 (token, restApi, query = '', signal = {}) {
        const headers = {
            Authorization: 'Bearer ' + token
        }

        try {

            const response = await axios.get(restApi + 'partner/projects/marketplaceV2' + query, { headers })        
            return response.data.data
        } catch (e) {
            captureApiException(e, 'marketplace.js', 'fetchMarketplaceV2')
            console.error(e)
        }
    }

    function setProjectId (id) {
        projectId.value = id
    }

    function setTopJobs (id) {
        topJobs.value = id
    }

    return { projectId, topJobs, setProjectId, setTopJobs, fetchMarketplaceV2, fetchMarketplaceV6 }
})